<template lang="pug">
.map-app__about
    .map-app__about-container
        img(
            :src="imageLink"
            v-if="imageLink"
        )
        .map-app__about__tour-details
            div
                //- img(src="../static/itinerary-marker.svg").itinerary-icon
                MarkerIcon.itinerary-icon
                span {{ locationName }}
            div
                //- img(src="../static/itinerary-distance.svg").itinerary-icon
                DistanceIcon.itinerary-icon
                span {{ distance }}
            div
                //- img(src="../static/itinerary-timer.svg").itinerary-icon
                TimeIcon.itinerary-icon
                span {{ time }}
        .map-app__about-container-body
            div(v-html="description")
            .map-app__about-container-buttons
                ul
                    li(
                        v-if="button1Url"
                        :style="!button2Url ? {'width': '100%'}: ''"
                    )
                        a(
                            :href="button1Url"
                            :class="`o-btn o-btn--large btn ${button1Style}`"
                        ) {{ button1Text }}
                    li(
                        v-if="button2Url"
                    )
                        a(
                            :href="button2Url"
                            :class="`o-btn o-btn--large btn ${button2Style}`"
                        ) {{ button2Text }}
</template>

<script>
import MarkerIcon from '../static/itinerary-marker.svg'
import DistanceIcon from '../static/itinerary-distance.svg'
import TimeIcon from '../static/itinerary-timer.svg'

export default {
    name: 'about',
    props: ['data'],
    data() {
        return {
            description: '',
            imageLink: '',
            locationName:'default',
            distance: '400m',
            time: '1 hour',
            button1Url: '',
            button1Style: '',
            button1Text: '',
            button2Url: '',
            button2Style: '',
            button2Text: '',
        }
    },
    mounted() {
        // console.log('mapAbout data', this.data)
        this.description = this.data.aboutDescription
        this.imageLink = this.removeTilde(this.data.aboutImageLink)
        this.locationName = this.data.aboutLocationName
        this.distance = this.data.aboutDistance
        this.time = this.data.aboutTime

        // about buttons
        this.button1Style = this.data.button1Style ? this.data.button1Style : ''
        this.button1Url = this.data.button1Url ? this.data.button1Url : ''
        this.button1Text = this.data.button1Text ? this.data.button1Text : ''
        this.button2Style = this.data.button2Style ? this.data.button2Style : ''
        this.button2Url = this.data.button2Url ? this.data.button2Url : ''
        this.button2Text = this.data.button2Text ? this.data.button2Text : ''

        this.$root.$emit('tab-page-active', 'about')
    },
    methods: {
        removeTilde(str) {
            let url = str
            if (str.includes('~')) {
                url = str.replace('~', '')
            }
            return url
        },
    },
    components: {
        MarkerIcon,
        DistanceIcon,
        TimeIcon,
    },
}
</script>

<style lang="scss">
@import "../scss/variables";

.map-app__about {
    overflow: auto;

    &-container {
        position: relative;
        width: 100%;
        opacity: 1;
        background: $white;
        overflow: auto;
        padding: 0 2rem 5rem;
        font-size: 1rem;

        &-body {
            overflow: auto;
        }

        img {
            width: 100%;
            padding-bottom: 1rem;
        }

        &-buttons {
            ul {
                list-style: none;
                display: flex;
                flex-direction: row;
                padding: 2rem 0 1rem;
                margin: 0;

                li {
                    margin: 0 0.25rem 0 0;
                    width: 50%;

                    &:last-child {
                        margin: 0 0 0 0.25rem;
                    }

                    a {
                        font-size: 1rem;
                        width: 100%;
                        padding: 10px;
                    }
                }

            }
        }
    }

    &__tour-details {
        padding-bottom: 15px;
        
        .itinerary-icon {
            position: relative;
            width: 19px;
            height: 35px;
            top: 7px;
            left: 0;
            margin-right: 15px;
        }
    }
}
</style>